import i18n from '@dms/i18n';

import {VEHICLE_FORM_EVENTS} from '../../core/machine/constants/VEHICLE_FORM_EVENTS';
import {MechanicalReplacementServiceIntervals} from '../../core/types/RentalVehicle';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

interface ReplacementAfterMileageInputProps {
  name: MechanicalReplacementServiceIntervals;
}

/**
 * Numeric input component for defining the mileage interval after which a vehicle component should be replaced.
 * Used in service interval tracking to set the replacement frequency based on vehicle mileage.
 * Automatically calculates the next replacement mileage when changed.
 *
 * @param props.name - The component name (e.g., 'engineOil', 'gearboxOil', 'timingBelt')
 */
export function ReplacementAfterMileageInput(props: ReplacementAfterMileageInputProps) {
  const {sendMachineEvent} = useVehicleFormContext();

  const handleChange = (value: number | null) => {
    sendMachineEvent({
      type: VEHICLE_FORM_EVENTS.LAST_REPLACEMENT_MILEAGE_INTERVAL_CHANGED,
      name: props.name,
      value,
    });
  };

  return (
    <Field
      type="number"
      name={`serviceIntervals.${props.name}.replacementAfterMileage`}
      label={i18n.t('entity.vehicle.labels.replacementAfterMileage')}
      suffix={i18n.t('general.metric.km')}
      onChange={handleChange}
    />
  );
}
